import React from 'react';
import { Controller } from 'react-hook-form';
import { getCurrencySymbol } from 'app/BargainWidget/Bargains/utils/currency-utils';
import ErrorMessage from 'app/BargainWidget/Bargains/WidgetV1/components/forms/ErrorMessage';
import { getMinimumPrice } from 'app/BargainWidget/Bargains/utils/bargain-utils';

const OfferPriceFieldV1 = ({ label, placeholder, control, bargainData, translation, widgetSettings, currentVariant }) => {
  return (
    <Controller
      name="offerPrice"
      control={control}
      rules={{
        required: 'Offer Price is required!',
        min: {
          value: 0,
          message: 'Offer Price must be equal or greater than 0!',
        },
        validate: (value) => {
          const minimumPriceCriteria = parseFloat(getMinimumPrice(bargainData, currentVariant?.price));
          if (bargainData?.applyMinimumPrice && parseFloat(value) < minimumPriceCriteria) {
            return (
              translation?.minimumPriceRequiredLabel?.replace('{{minimumPrice}}', getCurrencySymbol() + minimumPriceCriteria) ||
              `Please provide minimum amount ${minimumPriceCriteria}`
            );
          }
          return true;
        },
      }}
      render={({ field: { value, onChange, ...field }, fieldState }) => (
        <div className={" bargain-widget-v1-offer-price-field-block"}>
          <label style={{ '--form-label-text-color': widgetSettings?.contentFormLabelColor || '#4b5563' } as any} className="se-text-xs se-font-medium se-text-[var(--form-label-text-color)] se-mb-1.5 se-block bargain-widget-v1-input-field-label">{label}</label>
          <div className="se-relative bargain-widget-v1-offer-price-field-container">
            <span className="se-absolute se-left-4 se-top-1/2 se--translate-y-1/2 se-text-gray-400 se-text-sm bargain-widget-v1-offer-price-field-currency">
              {getCurrencySymbol()}
            </span>
            <input
              {...field}
              type="number"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              className="se-w-full se-bg-gray-50 se-border-none se-rounded-xl se-px-8 se-py-2.5 focus:se-outline-none focus:se-ring-2 focus:se-ring-indigo-500/20 se-text-gray-800 se-text-sm se-transition-all se-duration-200 bargain-widget-v1-offer-price-field"
              placeholder={placeholder}
            />
          </div>
          <ErrorMessage fieldState={fieldState} />
        </div>
      )}
    />
  );
};

export default OfferPriceFieldV1;
